import {getColor} from "@/styles/ThemeConfig";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import CityTourCard from "@/components/city/cards/CityTourCard";
import HistoricalTourCard from "@/components/city/cards/HistoricalTourCard";

const ToursWrapper = styled.div`
    width: 100%;
    margin-top:40px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

const ToursSidebarTitle = styled.div`
    text-align: right;
    padding-bottom: 300px;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    writing-mode: vertical-lr;
    text-orientation: mixed;
    font: 52px Josefin Sans;
    font-weight: 700;
    letter-spacing: 3px;
    -webkit-text-fill-color: #fff;
    -webkit-text-stroke-color: #859f95;
    -webkit-text-stroke-width: 1px;
    text-transform: uppercase;

`;



const TourSimilarSectionWrapper = styled.div`
    margin: 30px 0;
    display: flex;
    overflow: visible;
    padding: 100px calc(50vw - 775px + 52px) 100px calc(50vw - 775px);
    align-items: stretch;
    @media only screen and (${breakpoints.mobile}) {
        padding: 20px;
    }
`
export default function TourSimilarSection({title, subtitle,sidebarTitle, tours, historicalTour}) {


    return <div style={{display:'flex',justifyContent:'center', width:'100%'}}>
        {
            ((tours && tours?.length > 0) || historicalTour?.title) && <TourSimilarSectionWrapper>
                <ToursSidebarTitle className={'desktop_only'} aria-hidden="true">{sidebarTitle}</ToursSidebarTitle>
                <div>
                    {title && <h2 style={{
                        textTransform: 'uppercase',
                        fontSize: '26px',
                        font: 'Josefin Sans',
                        letterSpacing: '4px',
                        color: getColor('gold'),
                    }}>
                        {title}
                    </h2>}
                    {subtitle && <p style={{
                        textTransform: 'uppercase',
                        fontSize: '24px',
                        font: 'Josefin Sans',
                        fontWeight: 'bold',
                        color: getColor('gold'),
                    }}> {subtitle}</p>}


                    <ToursWrapper>
                        {
                            tours?.map((item, index) => {
                                return <CityTourCard key={index} item={item}/>
                            })
                        }

                        {
                            historicalTour &&
                            <HistoricalTourCard
                                rating={historicalTour?.rating}
                                title={historicalTour?.title}
                                description={historicalTour?.description}
                                buttonText={historicalTour?.buttonText}
                                buttonLink={historicalTour?.buttonLink}
                                image={historicalTour?.image}
                            />
                        }
                    </ToursWrapper>
                </div>
            </TourSimilarSectionWrapper>
        }

    </div>

}
